import {
  getLayout,
  getPaint,
  getStyleType,
  getTextField,
  getRanchPaint,
} from './layerStyler'

export default function allRanchParcels(map, features) {
  var ranchParcelsSource = {
    key: 'all_ranches',
    id: 'all_ranches',
    type: 'geojson',
    data: features,
  }

  var ranchParcelsLayer = {
    id: 'All Ranches',
    type: getStyleType('MULTIPOLYGON'),
    source: 'all_ranches',
    layout: getLayout('MULTIPOLYGON', 'visible'),
    paint: getPaint('MULTIPOLYGON', '#D74C00'),
  }

  var ranchParcelsOutlineLayer = {
    id: 'All Ranches_outline',
    type: 'line',
    source: 'all_ranches',
    layout: getLayout('OUTLINE', 'visible'),
    paint: {
      'line-color': [
        'case',
        ['has', 'selected'],
        ['get', 'selected'],
        ['has', 'hex'],
        ['get', 'hex'],
        ['to-color', '#D74C00'],
      ],
      'line-width': 4,
    },
  }

  return { ranchParcelsSource, ranchParcelsLayer, ranchParcelsOutlineLayer }
}
